export default class Observable {
  _state

  listeners

  constructor(initialState) {
    this._state = initialState
    this.listeners = []
  }

  subscribe = (listener) => {
    this.listeners.push(listener)
    return () => {
      this.listeners.splice(this.listeners.indexOf(listener), 1)
    }
  }

  subscriberCount() {
    return this.listeners.length
  }

  setState = (newState) => {
    this._state = newState
    this.listeners.forEach((listener) => listener(this._state))
  }

  state() {
    return this._state
  }
}
